import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

export const trackFeatureAppReady = (trackingService: TrackingServiceV2) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'feature_app_ready',
          eventName: 'vtp standard and optional equipment - feature app ready',
        },
        attributes: {
          componentName: 'vtp-standard-and-optional-equipment',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: '',
          value: '',
          pos: '',
        },
      },
      componentUpdate: {
        attributes: {
          implementer: 2,
        },
      },
    });
  }
};

export const registerImpressionTracking = (trackingService: TrackingServiceV2, ref: any) => {
  if (trackingService) {
    if (ref !== null) {
      trackingService.registerImpressionTracking(ref.current, () => {
        return {
          event: {
            eventInfo: {
              eventAction: 'impression',
              eventName: 'vtp standard and optional equipment - impression',
            },
            attributes: {
              componentName: 'vtp-standard-and-optional-equipment',
              label: '',
              targetURL: '',
              clickID: '',
              elementName: '',
              value: '',
              pos: '',
            },
          },
        };
      });
    }
  }
};

export const infoLinkTracking = (
  trackingService: TrackingServiceV2,
  isStandardEquipment: boolean,
  productHeadline: string | undefined
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'content',
          eventName: isStandardEquipment
            ? 'vtp standard equipment info click - layer open'
            : 'vtp optional equipment info click - layer open',
        },
        attributes: {
          componentName: 'vtp-standard-and-optional-equipment',
          label: productHeadline,
          clickID: '',
          elementName: 'text link',
          value: 'image',
          pos: '',
          targetURL: '',
        },
      },
    });
  }
};

export const videoIconTracking = (
  trackingService: TrackingServiceV2,
  isStandardEquipment: boolean,
  productHeadline: string | undefined
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'internal_link',
          eventName: isStandardEquipment
            ? 'vtp standard equipment info click - layer open'
            : 'vtp optional equipment info click - layer open',
        },
        attributes: {
          componentName: 'vtp-standard-and-optional-equipment',
          label: productHeadline,
          clickID: '',
          elementName: 'icon',
          value: 'video',
          pos: '',
        },
      },
    });
  }
};

export const tyreLabelTracking = (
  trackingService: TrackingServiceV2,
  tyreLabelButtonText: string
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'content',
          eventName: 'vtp standard equipment - tyre label click',
        },
        attributes: {
          componentName: 'vtp-standard-and-optional-equipment',
          label: tyreLabelButtonText,
          targetURL: '',
          clickID: '',
          elementName: 'text link',
          value: '',
          pos: '',
        },
      },
    });
  }
};
